import clsx from "clsx";
import {InputHTMLAttributes} from "react";

import * as styles from "./style.module.css";

interface IBlock extends InputHTMLAttributes<HTMLDivElement> {
    flexDirection?: 'row' | 'column';
    expandPadding?: boolean;
}

const Block = ({
                   children,
                   className,
                   expandPadding = false,
                   flexDirection = 'row',
                   ...props
               }: IBlock) => {
    const componentClassName = clsx(
        styles.container,
        flexDirection && styles[flexDirection],
        expandPadding && styles.expandPadding,
        className
    );

    return (
        <div {...props} className={componentClassName}>
            {children}
        </div>
    );
};

export default Block;